import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./SiteManagement.css";
import view from "../../images/view.png";
import { useNavigate } from "react-router-dom";
import Header from "../HeaderAdmin";
import Navbar from "../Navbar.js";
import { SITE_MANAGEMENT_DETAILS } from "../ApiDetails.js";

function SiteDetails() {
  const [events, setEvents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  // site details variables
  const [siteCode, setSiteCode] = useState([]);
  const [unit, setUnit] = useState([]);
  const [businessUnit, setbusinessUnit] = useState([]);
  const [region, setRegion] = useState([]);
  const [address, setAddress] = useState([]);
  const [city, setCity] = useState([]);
  const [country, setCountry] = useState([]);
  const [telecopier, setTelecopier] = useState([]);
  const [longitude, setLongitude] = useState([]);
  const [latitude, setLatitude] = useState([]);
  const [phoneNo, setPhoneNo] = useState([]);
  const [siteOpeningAnnivDate, setSiteOpeningAnnivDate] = useState([]);
  const [siteTypeString, setSiteTypeString] = useState([]);
  

  const isEditMode = location.state && location.state.site;

  useEffect(() => {
    if (location.state && location.state.site) {
      const { site } = location.state;

      setSiteCode(site.site_code);
      setUnit(site.unit);
      setRegion(site.region);
      setbusinessUnit(site.business_unit.replace(",",", "));
      setCountry(site.country);
      setAddress(site.address);
      setCity(site.city);
      setTelecopier(site.telecopier);
      setSiteTypeString(site.siteTypeString?.replace(",",", "));
      setPhoneNo(site.phone_number);
      setLongitude(site.longitude);
      setLatitude(site.latitude);
      setSiteOpeningAnnivDate(site.move_in_date);
    }
  }, [isEditMode, location.state]);

  useEffect(() => {
    fetchEvents(siteCode);
  }, [siteCode]);

  useEffect(() => {
    calculateTotalPages(events);
  }, [events]);

  const fetchEvents = async (siteCode) => {
    try {
      if (siteCode.length > 0) {
        const response = await axios.get(`${SITE_MANAGEMENT_DETAILS}/${siteCode}`);
        const data = response.data;
        setEvents(data);
        calculateTotalPages(data);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEventview = (event) => {
    if (event.id) {

      const url = `/GetDetailAdmin/${event.eventId}`;
      // navigate(url, { state: { hideFooter: true } });
      navigate(url);
    }
  };


  const calculateTotalPages = (data) => {
    const total = Math.ceil(data.length / pageSize);
    setTotalPages(total);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;

    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxPageNumbersToShow / 2)
    );
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage + 1 < maxPageNumbersToShow) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const currentPageData = events.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <>
      <Header />

      <div
        style={{
          padding: "40px",
        }}
      >
        <Navbar />
        <div className="container-fluid">
          <div className="row m-4">
            {/* heading section */}
            <div className="m-2 bg-light rounded p-3">
              <div className="large-custom-font">
                {siteCode} - {unit}
              </div>
            </div>

            {/* Details Section */}
            <div className="m-2 bg-light rounded p-3">
              <div className="row bg-light rounded p-3">
                {/* First Column */}
                <div className="col-md-6">
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Site code:</label>
                    <div className="col-sm-8 col-form-label">{siteCode}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Unit:</label>
                    <div className="col-sm-8 col-form-label">{unit}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Business unit:</label>
                    <div className="col-sm-8 col-form-label">{businessUnit}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Region:</label>
                    <div className="col-sm-8 col-form-label">{region}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Address:</label>
                    <div className="col-sm-8 col-form-label">{address}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">City:</label>
                    <div className="col-sm-8 col-form-label">{city}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Country:</label>
                    <div className="col-sm-8 col-form-label">{country}</div>
                  </div>
                </div>

                {/* Second Column */}
                <div className="col-md-6">
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Site type:</label>
                    <div className="col-sm-8 col-form-label">{siteTypeString}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Phone number:</label>
                    <div className="col-sm-8 col-form-label">{phoneNo}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Telecopier:</label>
                    <div className="col-sm-8 col-form-label">{telecopier}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Latitude:</label>
                    <div className="col-sm-8 col-form-label">{latitude === null ? 0 : latitude}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Longitude:</label>
                    <div className="col-sm-8 col-form-label">{longitude === null ? 0 : longitude}</div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">Opening anniversary date:</label>
                    <div className="col-sm-8 col-form-label">{new Date(siteOpeningAnnivDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table section */}
            <div className="m-2 bg-light rounded p-0">
              <div className="container-fluid listitemsadmin listitems p-3">
                <div className="table-responsive">
                  <div className="table">
                    <div className="row custom-table-font-header bg-light p-3 rounded m-3">
                      <div className="col-12 col-md-3">Date</div>
                      <div className="col-12 col-md-3">Estimated attendees</div>
                      <div className="col-12 col-md-3">Touches</div>
                      {/* <div className="col-12 col-md-2">OffSite</div> */}
                      <div className="col-12 col-md-3"></div>
                    </div>
                    {currentPageData.length > 0 ? (
                      currentPageData.map((event, index) => (
                        <div
                          className="row custom-table-tr bg-light p-3 rounded m-3 align-items-center"
                          key={index}
                        >
                          <div className="col-12 col-md-3">{new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</div>
                          <div className="col-12 col-md-3">{event.totalAttendees}</div>
                          <div className="col-12 col-md-3"></div>
                          <div className="col-12 col-md-3 text-end">
                            <button
                              className="btn btn-icon"
                              onClick={() => handleEventview(event)}
                            >
                              <img
                                src={view}
                                alt="Edit"
                                width={24}
                                height={24}
                              />
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="row bg-light p-2 rounded m-3 align-items-center">
                        <div className="col-12 text-center">No Events Found</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
                <div className="paging align-items-center" style={{userSelect: 'none'}}>
                    <span className="centered-text">
                        {(totalPages>0) && (<>{(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, events.length)} OF{" "}</>)}
                        {events.length} ELEMENTS &nbsp;&nbsp;
                    </span>
                    <nav>
                        <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                            <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                            </li>
                            <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                            </li>
                            {getPageNumbers().map((number) => (
                                <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                    <span className="page-link" onClick={() => handlePageChange(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                                </li>
                            ))}
                            <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                            </li>
                            <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SiteDetails;






